import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_return_top",
  "use": "icon-ic_return_top-usage",
  "viewBox": "0 0 18 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 10\" id=\"icon-ic_return_top\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3 17V-7h24v24z\" /><path fill=\"#999\" fill-rule=\"nonzero\" d=\"M1.644 9.923 0 8.384 8.959 0 18 8.462 16.356 10 8.96 3.077z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol